import React from 'react';
import { motion } from 'framer-motion';
import { HelpCircle } from 'lucide-react';
import { FAQ_SECTIONS } from '../data/faqs';

const fadeUp = { hidden: { opacity: 0, y: 16 }, visible: { opacity: 1, y: 0 } };
const stagger = { visible: { transition: { staggerChildren: 0.04 } } };

export default function Faq({ offsetTop = false }) {
  return (
    <div
      className={`px-6 md:px-8 lg:px-10 pb-16 max-w-3xl mx-auto ${offsetTop ? 'pt-28' : 'pt-8'}`}
      data-testid="faq-page"
    >
      <div className="mb-8">
        <h1 className="font-heading text-3xl font-semibold text-slate-800 flex items-center gap-2">
          <HelpCircle className="w-6 h-6 text-teal-600" /> Frequently Asked Questions
        </h1>
        <p className="text-sm text-slate-500 mt-1">Everything you need to know about how Udvega works.</p>
      </div>

      <div className="space-y-10">
        {FAQ_SECTIONS.map((section) => (
          <div key={section.title}>
            <h2 className="text-xs font-semibold uppercase tracking-wider text-teal-600 mb-3">{section.title}</h2>
            <motion.div initial="hidden" animate="visible" variants={stagger} className="space-y-4">
              {section.items.map((item, i) => (
                <motion.div key={i} variants={fadeUp} className="glass-card rounded-2xl p-6">
                  <h3 className="font-heading font-semibold text-slate-800 mb-2">{item.q}</h3>
                  <p className="text-sm text-slate-600 leading-relaxed">{item.a}</p>
                </motion.div>
              ))}
            </motion.div>
          </div>
        ))}
      </div>
    </div>
  );
}
